module.exports = __webpack_public_path__ + "static/media/welcome-modal-therapy-coaching.be6cbba5.jpg";